import React, { FC, useCallback, useEffect } from 'react';
import styles from './MobileVerificationInput.module.less';
import { WhatsAppData } from '../../models/UserModels';
import { PhoneInput } from '../PhoneInput/PhoneInput';

type Props = {
  value?: WhatsAppData;
  onChange?: (value: WhatsAppData) => void;
  placeholder?: string;
  defaultCountry?: string;
  mobile?: string;
  sameAsMobile?: boolean;
};
export const WhatsAppInput: FC<Props> = (props) => {
  const { value, defaultCountry, placeholder, onChange } = props;
  const handlerInputChange = useCallback(
    (text) => {
      const temp = { ...value };
      temp.whatsapp = text;
      onChange?.(temp);
    },
    [onChange, value],
  );

  return (
    <div className={styles.inputHolder}>
      <PhoneInput
        defaultCountry={defaultCountry}
        placeholder={placeholder}
        style={{ width: '100%' }}
        onChange={handlerInputChange}
        value={value?.whatsapp}
      />
    </div>
  );
};
